import React, { useState } from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './components/HomePage';
import MainApp from './components/MainApp';
import AccessScreen from './components/AccessScreen';

function App() {
  const [hasAccess, setHasAccess] = useState(() => {
    return localStorage.getItem('sunosync_access') === 'true';
  });

  const handleAccessSuccess = () => {
    localStorage.setItem('sunosync_access', 'true');
    setHasAccess(true);
  };

  return (
    <HashRouter>
      <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-rose-100/50 font-sans selection:bg-orange-200 selection:text-orange-900 overflow-x-hidden flex flex-col">
        {/* Background Graphic for authenticated routes */}
        <div className="absolute top-0 left-0 w-full h-96 bg-gradient-to-b from-orange-100/50 to-transparent pointer-events-none z-0" />
        
        <Routes>
          {/* Public Homepage */}
          <Route path="/" element={<HomePage />} />
          
          {/* Protected App Route */}
          <Route 
            path="/app" 
            element={
              hasAccess ? (
                <MainApp />
              ) : (
                <AccessScreen onAccess={handleAccessSuccess} />
              )
            } 
          />
          
          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </HashRouter>
  );
}

export default App;